export const ProductListItem = {
    template: '#search-product-template',
    props: {
        product: {
            id: "",
            name: "",
            shortDescription: "",
            url: "",
            isNewProduct: false,
            isNewestVersion: false,
            isFree: false,
            formats: [],
            standardStatusText: "",
            standardStatus: 0,
            standardStatusDate: "",
            standardDocumentType: "",
            languages: []
        }
    },
    methods: {
        findElement: function (selector) {
            return $(this.$el).find(selector);
        },
        getFormatClass: function (format) {
            switch (format) {
                case 31: // pdf
                    return "far fa-file-pdf text-size-1-4";
                case 32: // redline
                    return "far icon-redline blue-dark";
                case 33: // paper
                    return "fas fa-book";
                case 34: // database
                    return "fas fa-database";
                default:
                    return ""
            }
        },
        getFormatAriaLabel: function (format) {
            switch (format) {
                case 31: // pdf
                    return "PDF";
                case 32: // redline
                    return "PDF redline";
                case 33: // paper
                    return "Paper";
                case 34: // database
                    return "Database";
                default:
                    return ""
            }
        },
        addItemToMonitoring: function (productId) {
            var monitoringData = new FormData();
            monitoringData.append('productId', productId);
            var self = this;
            axios({
                method: 'post',
                url: "monitoringservice/addtomonitoring",
                data: monitoringData,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            })
                .then(function () {
                    self.findElement('#item-added-to-monitoring-modal').modal('show');
                })
                .catch(function () {
                    self.findElement('#monitoring-error-modal').modal('show');
                });
        }
    },
    computed: {
        statusClass: function () {
            switch (this.product.standardStatus) {
                case (1): //draft
                    return "badge-primary";
                case (2): //valid
                    return "badge-success";
                case (3): //withdrawn
                    return "badge-danger";
                default:
                    return "";
            }
        }
    }
};
